import { EntryPoint } from "./src/EntryPoint"
import { setupWebPlatform } from "./src/platform/web/setupWebPlatform"

setupWebPlatform()

export default EntryPoint
